const LS_APP_PREFIX = 'wp-content-publisher';

export const setLocalStorage = (key: string, value: string) => {
    localStorage.setItem(`${LS_APP_PREFIX}-${key}`, value);
};

export const getLocalStorage = (key: string) => {
    return localStorage.getItem(`${LS_APP_PREFIX}-${key}`);
};

export const removeLocalStorage = (key: string) => {
    localStorage.removeItem(`${LS_APP_PREFIX}-${key}`);
};

export const clearLocalStorage = () => {
    localStorage.clear();
};